import { render, staticRenderFns } from "./itemSubGroup.vue?vue&type=template&id=750daaf0"
import script from "./itemSubGroup.vue?vue&type=script&lang=js"
export * from "./itemSubGroup.vue?vue&type=script&lang=js"
import style0 from "./itemSubGroup.vue?vue&type=style&index=0&id=750daaf0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('750daaf0')) {
      api.createRecord('750daaf0', component.options)
    } else {
      api.reload('750daaf0', component.options)
    }
    module.hot.accept("./itemSubGroup.vue?vue&type=template&id=750daaf0", function () {
      api.rerender('750daaf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/itemSubGroup.vue"
export default component.exports